/* Private NeuroFuel test: real variants, native money, bounded decorative animation. */
(() => {
  if (customElements.get('neurofuel-test-builder')) return;
  const fallback = {"choose_size":"Choose your kit size","kit_size":"Kit size","one_kit":"1 Kit","two_kits":"2 Kits","three_free":"3 + 1 Free","popular":"POPULAR","super_deal":"SUPER DEAL!","gift_strip":"🎁 +1 ARK Melts FREE","bottle":"Bottle","pack":"Pack","select_drops":"Select Drops","select_melts":"Select Melts","add_product":"Add [product]","remove_slot":"Remove [slot]","remove_product":"Remove [product] from [slot]","your_order":"Your order","progress":"[count] of [total] items","gift_title":"Your free ARK Melts","gift_note":"Original · 1 pack, on us.","free":"FREE","purchase_option":"Purchase option","subscribe":"Subscribe","once":"One-time purchase","once_note":"One-time purchase selected. No subscription.","unconnected":"Subscription unavailable","choose_mix":"Choose your mix","complete_kit":"Complete your kit","frequency":"Delivery frequency","every_weeks":"Every [count] weeks","you_save":"You save","saving":"You save [amount]","saving_gift":"You save [amount] including your free gift","cancel":"Cancel, skip or edit anytime","extra_discount":"Extra [percent]% discount","extra_sub_discount":"Extra [percent]% subscription discount","save_percent":"SAVE [percent]%","remove_hint":"Tap × to remove an item and change your mix.","enable_js":"Please enable JavaScript to choose your bundle.","load_error":"The bundle selector could not load. Please refresh the page.","mix_unavailable":"This combination is unavailable. Please choose another kit.","sold_out":"This combination is currently sold out.","draft":"Draft preview only — checkout is disabled.","add_drops":"Add your ARK Drops","rewards":"Bundle rewards","bottles":"[count] bottles","ready":"Your bundle is ready","free_melts":"Free ARK Melts","best_price":"Best price","gift_energy":"Energy & focus to complement your Drops.","free_shipping":"Free shipping","per_bottle":"/bottle","min_bottles":"Choose at least 2 bottles","add_bottle":"Add a bottle","add_gift":"Add for free gift","add_save":"Add more, save more","atc":"Add to Cart","off":"[percent]% OFF","unavailable":"Currently unavailable","unlocked":"unlocked","locked":"not yet unlocked","start_one":"Add 1 more bottle to start your bundle.","start_two":"Add 2 bottles to start your bundle.","next_gift":"Add 1 more bottle to unlock free Melts.","gift_reached":"Free Melts unlocked. Add 1 to save more.","all_reached":"Best price and free Melts unlocked!","shipping_announcement":"FREE STANDARD POSTNORD SHIPPING FROM [amount]","shipping_remaining":"Add [amount] more for free Standard PostNord shipping.","shipping_reached":"You have unlocked free Standard PostNord shipping."};
  class NeurofuelTestBuilder extends HTMLElement {
    t(key, values = {}) {
      const copy = this.config?.i18n?.[key] || fallback[key] || key;
      return copy.replace(/\[([a-z]+)\]/g, (token, name) => Object.hasOwn(values, name) ? String(values[name]) : token);
    }
    planLabel(plan) { const weeks = this.config?.planWeeks?.[plan.id]; return weeks ? this.t('every_weeks', {count:weeks}) : plan.name; }

    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      this.animations = new Set();
      this.giftAnimations = new Set();
      this.giftShown = false;
      window.addEventListener('resize', () => this.stopAnimations(), {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => {if(document.hidden)this.stopAnimations();}, {signal:this.abort.signal});
      matchMedia('(prefers-reduced-motion: reduce)').addEventListener?.('change', event => {if(event.matches)this.stopAnimations();}, {signal:this.abort.signal});
      this.form = this.querySelector('form');
      this.submit = this.querySelector('[data-nf-submit]');
      this.status = this.querySelector('[data-nf-status]');
      try {
        this.config = JSON.parse(this.querySelector('[data-nf-config]').textContent);
        if (this.config.productId !== '16022687514968' || this.config.variants.length !== 29) throw Error('Invalid test configuration');
        const keys = this.config.variants.map(v => v.options.join('|||'));
        if (new Set(keys).size !== 29) throw Error('Duplicate combination');
        if (new Set(this.config.variants.map(v=>v.id)).size !== 29 || this.config.variants.some(v=>!/^\d+$/.test(v.id)||!Number.isFinite(v.price)||v.price<0||!Number.isFinite(v.compare)||!['Single','Double','Triple + 1 free'].includes(v.options[2]))) throw Error('Invalid variant data');
        this.variants = new Map(this.config.variants.map(v => [v.options.join('|||'), v]));
        this.choices = {};
        for (const group of ['drops', 'melts']) {
          this.choices[group] = new Map(Array.from(this.querySelectorAll(`[data-nf-add][data-nf-group="${group}"]`), b => [b.dataset.nfValue, b]));
        }
        // Honour explicit variant links; ordinary visits start with one empty kit.
        const initial = this.config.variants.find(v => v.id === this.config.selectedId);
        this.n = initial ? this.tier(initial.options[2]) : 1;
        this.drops = initial ? this.expand(initial.options[0], 'Lemon Ice', this.n) : [null];
        this.melts = initial ? this.expand(initial.options[1], 'Extra Strong', this.n) : [null];
        this.purchase = 'subscription';
        this.planId = '';
        this.planSelect = this.querySelector('[data-nf-plan]');
        this.planTrigger = this.querySelector('[data-nf-plan-trigger]');
        this.planMenu = this.querySelector('[data-nf-plan-menu]');
        this.dropdown = this.querySelector('[data-nf-dropdown]');
        this.planSelect.addEventListener('change', () => {this.planId = this.planSelect.value; this.setPlanOpen(false); this.paint();}, {signal:this.abort.signal});
        this.dropdown.addEventListener('keydown', event => this.onPlanKey(event), {signal:this.abort.signal});
        this.dropdown.addEventListener('focusout', event => {
          if (!this.dropdown.contains(event.relatedTarget)) this.setPlanOpen(false);
        }, {signal:this.abort.signal});
        document.addEventListener('click', event => {
          if (!this.dropdown.contains(event.target)) this.setPlanOpen(false);
        }, {signal:this.abort.signal});
        this.querySelectorAll('[data-nf-tier]').forEach(button => {
          if (button.querySelector('[data-nf-tier-saving]')) return;
          const badge = document.createElement('small'); badge.className = 'nf-tier-saving'; badge.dataset.nfTierSaving = '';
          button.querySelector('.nf-tier-copy').append(badge);
        });
        this.addEventListener('click', event => {
          const target = event.target.closest('button');
          if (!target || !this.contains(target)) return;
          if (target.hasAttribute('data-nf-plan-trigger')) {
            this.setPlanOpen(this.planMenu.hidden);
          } else if (target.hasAttribute('data-nf-plan-option')) {
            this.planSelect.value = target.dataset.nfPlanOption;
            this.planSelect.dispatchEvent(new Event('change', {bubbles:true}));
            this.planTrigger.focus({preventScroll:true});
          } else if (target.hasAttribute('data-nf-purchase')) {
            if (target.disabled) return;
            this.purchase = target.dataset.nfPurchase;
            this.paint();
          } else if (target.hasAttribute('data-nf-tier')) {
            this.stopAnimations();
            this.n = Number(target.dataset.nfTier);
            this.drops = this.resize(this.drops, this.n);
            this.melts = this.resize(this.melts, this.n);
            this.paint();
          } else if (target.hasAttribute('data-nf-add')) {
            const group = target.dataset.nfGroup, value = target.dataset.nfValue;
            const index = this.addChoice(group, value);
            if (index === -1) return;
            this.paint();
            const slot = this.querySelector(`[data-nf-slot][data-nf-group="${group}"][data-nf-index="${index}"]`);
            this.fly(target.querySelector('img'), slot.querySelector('img'));
            // Keep a useful focus target when the final plus becomes disabled.
            if (target.disabled) slot.querySelector('[data-nf-remove]').focus({preventScroll:true});
          } else if (target.hasAttribute('data-nf-remove')) {
            const slot = target.closest('[data-nf-slot]'), group = slot.dataset.nfGroup;
            this.stopAnimations();
            this[group][Number(slot.dataset.nfIndex)] = null;
            this.paint();
            this.choices[group].values().next().value.focus({preventScroll:true});
          }
        }, {signal:this.abort.signal});
        // Prevent invalid/partial kits before the native theme cart handler runs.
        this.form.addEventListener('submit', event => {
          if (!this.valid || this.config.preview || this.submit.disabled) {
            event.preventDefault(); event.stopImmediatePropagation(); return;
          }
          this.form.elements.id.value = this.variant.id;
          this.form.elements.quantity.value = '1';
          const plan = this.purchase === 'subscription' ? this.variant.plans?.find(p => p.id === this.planId) : null;
          if (this.purchase === 'subscription' && !plan) {event.preventDefault(); event.stopImmediatePropagation(); return;}
          this.form.elements.selling_plan.disabled = !plan;
          this.form.elements.selling_plan.value = plan?.id || '';
        }, {capture:true, signal:this.abort.signal});
        this.paint();
        this.dataset.ready = 'true';
      } catch (_) {
        this.abort.abort();
        this.abort = new AbortController();
        this.valid = false;
        this.dataset.ready = 'false';
        this.form.addEventListener('submit', event => {event.preventDefault();event.stopImmediatePropagation();}, {capture:true,signal:this.abort.signal});
        this.submit.disabled = true;
        this.form.elements.id.disabled = true;
        this.status.textContent = this.t('load_error');
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.stopAnimations(); this.bound = false; }
    tier(pack) { return pack === 'Double' ? 2 : pack === 'Triple + 1 free' ? 3 : 1; }
    expand(value, alternate, n) {
      const count = value === alternate ? n : value === 'Original' ? 0 : Number(value.match(/\+ (\d+) /)?.[1]);
      if (!Number.isInteger(count) || count < 0 || count > n) throw Error('Invalid count');
      return Array(n-count).fill('Original').concat(Array(count).fill(alternate));
    }
    resize(values, n) { return Array.from({length:n}, (_,i) => values[i] || null); }
    addChoice(group, value) {
      if (!this.choices[group]?.has(value)) return -1;
      const index = this[group].indexOf(null);
      if (index !== -1) this[group][index] = value;
      return index;
    }
    option(values, alternate) {
      if (values.length !== this.n || values.some(v => v !== 'Original' && v !== alternate)) return null;
      const count = values.filter(v => v === alternate).length;
      return count === 0 ? 'Original' : count === this.n ? alternate : `${this.n-count} Original + ${count} ${alternate}`;
    }
    percentage(reference, price) {return reference > 0 ? Math.max(0,Math.round((reference-price)*100/reference)) : 0;}
    tierVariants(n) {return this.config.variants.filter(v => this.tier(v.options[2]) === n);}
    tierPlans(n) {
      const variants=this.tierVariants(n), first=variants[0]?.plans || [];
      // Only advertise frequencies genuinely allocated to every mix in this tier.
      return first.filter(p=>variants.every(v=>(v.plans||[]).some(a=>a.id===p.id&&Number.isFinite(a.price)&&a.price>=0)));
    }
    setPlanOpen(open) {
      open = !!open && !this.planTrigger.disabled;
      this.planMenu.hidden = !open;
      this.planTrigger.setAttribute('aria-expanded', String(open));
      this.planTrigger.querySelector('svg').classList.toggle('open', open);
    }
    onPlanKey(event) {
      if (event.key === 'Escape') {
        if (!this.planMenu.hidden) {event.preventDefault(); this.setPlanOpen(false); this.planTrigger.focus({preventScroll:true});}
        return;
      }
      if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key) || this.planTrigger.disabled) return;
      event.preventDefault();
      const options = Array.from(this.planMenu.querySelectorAll('[data-nf-plan-option]'));
      if (!options.length) return;
      const i = options.indexOf(document.activeElement);
      const selected = Math.max(0, options.findIndex(o => o.dataset.nfPlanOption === this.planId));
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length-1 : i < 0 ? selected : (i + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      this.setPlanOpen(true);
      options[next].focus({preventScroll:true});
    }
    paintPurchase() {
      const plans=this.tierPlans(this.n);
      const subscriptionButton=this.querySelector('[data-nf-purchase="subscription"]');
      subscriptionButton.disabled=!plans.length;
      if(!plans.length)this.purchase='once';
      if(!plans.some(p=>p.id===this.planId))this.planId=plans[0]?.id||'';
      const signature=plans.map(p=>p.id+'|'+p.name).join('||');
      if(this.planSelect.dataset.signature!==signature){
        this.setPlanOpen(false);
        this.planSelect.replaceChildren(...plans.map(p=>{const o=document.createElement('option');o.value=p.id;o.textContent=this.planLabel(p);return o;}));
        this.planMenu.replaceChildren(...plans.map(p=>{
          const button=document.createElement('button'); button.type='button'; button.setAttribute('role','option');
          button.className='kaching-subscriptions__dropdown-item'; button.dataset.nfPlanOption=p.id; button.tabIndex=-1;
          const wrapper=document.createElement('div'); wrapper.className='kaching-subscriptions__dropdown-item_label-and-price-wrapper';
          const labelWrapper=document.createElement('div'); labelWrapper.className='kaching-subscriptions__dropdown-item-label-wrapper';
          const label=document.createElement('span'); label.className='kaching-subscriptions__dropdown-item-label'; label.textContent=this.planLabel(p);
          labelWrapper.append(label);wrapper.append(labelWrapper);button.append(wrapper);return button;
        }));
        this.planSelect.dataset.signature=signature;
      }
      this.planSelect.value=this.planId;
      this.planSelect.disabled=this.purchase!=='subscription'||!plans.length;
      this.planTrigger.disabled=this.planSelect.disabled;
      if(this.planTrigger.disabled)this.setPlanOpen(false);
      this.querySelector('[data-nf-plan-label]').textContent=plans.find(p=>p.id===this.planId) ? this.planLabel(plans.find(p=>p.id===this.planId)) : '';
      this.planMenu.querySelectorAll('[data-nf-plan-option]').forEach(button=>{
        const selected=button.dataset.nfPlanOption===this.planId;
        button.classList.toggle('selected',selected);button.setAttribute('aria-selected',String(selected));
      });
      this.querySelector('[data-nf-sub-details]').hidden=this.purchase!=='subscription';
      this.querySelector('[data-nf-once-note]').hidden=this.purchase!=='once';
      this.querySelectorAll('[data-nf-purchase]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.nfPurchase===this.purchase)));
      const v=this.variant, sub=v?.plans?.find(p=>p.id===this.planId);
      const selected=this.purchase==='subscription'?sub:v;
      this.form.elements.selling_plan.value=this.purchase==='subscription'&&sub?sub.id:'';
      this.form.elements.selling_plan.disabled=!this.valid||this.purchase!=='subscription'||!sub;
      const hasSaving=!!v&&v.compare>v.price;
      this.querySelector('[data-nf-price]').textContent=v?.priceText||this.t('choose_mix');
      this.querySelector('[data-nf-sub-price]').textContent=!plans.length?this.t('unconnected'):sub?.priceText||this.t('choose_mix');
      this.querySelector('[data-nf-atc-price]').textContent=selected?.priceText||this.t('complete_kit');
      for(const name of ['compare','sub-compare']){
        const el=this.querySelector(`[data-nf-${name}]`);
        el.hidden=!hasSaving||(name==='sub-compare'&&!sub);el.textContent=el.hidden?'':v.compareText;
      }
      const saving=this.querySelector('[data-nf-saving]');
      saving.hidden=!selected||!v||v.compare<=selected.price;
      this.querySelector('[data-nf-saving-amount]').textContent=saving.hidden?'':selected.savingText;
      const example=v||this.tierVariants(this.n)[0],examplePlan=sub||example?.plans?.find(p=>p.id===this.planId);
      this.querySelector('[data-nf-extra-discount]').textContent=examplePlan?this.t('extra_discount',{percent:this.percentage(example.price,examplePlan.price)}):'';
      this.querySelectorAll('[data-nf-tier]').forEach(button=>{
        const n=Number(button.dataset.nfTier), variants=this.tierVariants(n), common=this.tierPlans(n);
        const subscribing=this.purchase==='subscription'&&common.length>0;
        const badgePlan=common.find(p=>p.id===this.planId)||common[0];
        const percentages=variants.map(x=>this.percentage(x.compare,subscribing?x.plans.find(p=>p.id===badgePlan.id).price:x.price));
        const low=Math.min(...percentages),high=Math.max(...percentages);
        const badge=button.querySelector('[data-nf-tier-saving]');badge.textContent=this.t('save_percent',{percent:low===high?low:`${low}–${high}`});
        badge.hidden=!low;
      });
    }
    stopAnimations() {
      this.stopGiftAnimations();
      this.animations?.forEach(a => {a.onfinish=null;a.oncancel=null;a.cancel();a.nfCleanup?.();});
      this.animations?.clear();
    }
    stopGiftAnimations() {
      for (const cleanup of [...(this.giftAnimations || [])]) cleanup();
    }
    giftMotion(element, frames, options, dispose = () => {}) {
      if (typeof element?.animate !== 'function') {dispose();return;}
      let animation;
      try {animation = element.animate(frames, options);} catch (_) {dispose();return;}
      let done = false;
      const cleanup = () => {
        if(done)return;done=true;
        this.giftAnimations.delete(cleanup);
        dispose();animation.onfinish=null;animation.oncancel=null;animation.cancel();
      };
      this.giftAnimations.add(cleanup);
      animation.onfinish=cleanup;animation.oncancel=cleanup;
    }
    celebrateGift(gift) {
      if (!gift || typeof gift.animate !== 'function' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Decorative only; all variant, price, selling-plan and validity updates already committed.
      try {
        this.stopGiftAnimations();
        const host=gift.parentElement, area=host.getBoundingClientRect(), box=gift.getBoundingClientRect();
        const x=box.left-area.left+box.width/2, y=box.top-area.top+box.height/2;
        const spread=Math.min(box.width*.43,150), colors=['#055c4d','#e9b32e','#53a88c','#f2d787'];
        for(let i=0;i<18;i++){
          const piece=document.createElement('span');piece.className='nf-gift-confetti';piece.setAttribute('aria-hidden','true');
          Object.assign(piece.style,{left:x+'px',top:y+'px',background:colors[i%colors.length],borderRadius:i%3===0?'50%':'2px'});
          host.append(piece);
          const dx=((i/17)*2-1)*spread,up=45+(i%5)*12,turn=(i%2?1:-1)*(160+i*17);
          this.giftMotion(piece,[
            {opacity:0,transform:'translate(-50%,-50%) scale(.3)',offset:0},
            {opacity:1,transform:'translate('+dx*.3+'px,'+(-up*.65)+'px) rotate('+turn*.3+'deg)',offset:.22},
            {opacity:1,transform:'translate('+dx*.75+'px,'+(-up)+'px) rotate('+turn*.65+'deg)',offset:.5},
            {opacity:0,transform:'translate('+dx+'px,32px) rotate('+turn+'deg) scale(.7)',offset:1}
          ],{duration:900+(i%3)*80,delay:180+(i%4)*20,easing:'cubic-bezier(.16,.6,.4,1)',fill:'backwards'},()=>piece.remove());
        }
        this.giftMotion(gift,[{opacity:0,transform:'translateY(12px) scale(.97)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:520,easing:'cubic-bezier(.22,1,.36,1)'});
        this.giftMotion(gift.querySelector('img'),[
          {opacity:0,transform:'translateY(18px) rotate(-14deg) scale(.65)',offset:0},
          {opacity:1,transform:'translateY(-6px) rotate(7deg) scale(1.12)',offset:.5},
          {opacity:1,transform:'translateY(2px) rotate(-3deg) scale(.97)',offset:.76},
          {opacity:1,transform:'translateY(0) rotate(0) scale(1)',offset:1}
        ],{duration:720,delay:130,easing:'ease-out',fill:'backwards'});
        this.giftMotion(gift.querySelector('.nf-free'),[
          {opacity:0,transform:'scale(.65) rotate(-8deg)'},{opacity:1,transform:'scale(1.12) rotate(3deg)',offset:.7},{opacity:1,transform:'scale(1) rotate(0)'}
        ],{duration:380,delay:380,easing:'ease-out',fill:'backwards'});
      } catch (_) {this.stopGiftAnimations();}
    }
    fly(source, destination) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !source?.animate || !source.complete || !source.naturalWidth) return;
      // Cosmetic only: selection and pricing have already committed synchronously.
      try {
        if (this.animations.size >= 6) this.stopAnimations();
        const a = source.getBoundingClientRect(), b = destination.getBoundingClientRect();
        const size = Math.min(a.width,a.height), targetSize = Math.min(b.width,b.height);
        if (!size || !targetSize) return;
        const left = a.left+(a.width-size)/2, top = a.top+(a.height-size)/2;
        const x = b.left+(b.width-targetSize)/2-left, y = b.top+(b.height-targetSize)/2-top, s = targetSize/size;
        const ghost = source.cloneNode();
        ghost.alt = ''; ghost.setAttribute('aria-hidden','true'); ghost.className = 'nf-flying-image no-lazy-loading';
        Object.assign(ghost.style, {left:`${left}px`,top:`${top}px`,width:`${size}px`,height:`${size}px`,transformOrigin:'top left'});
        this.append(ghost);
        destination.style.visibility = 'hidden';
        const animation = ghost.animate([
          {transform:'translate(0,0) scale(1)',offset:0,easing:'ease-in'},
          {transform:'translate(-2px,4px) scale(1.06,.9)',offset:.12,easing:'cubic-bezier(.15,.65,.35,1)'},
          {transform:`translate(${x*.28}px,-74px) rotate(-12deg) scale(.98,1.04)`,offset:.38,easing:'cubic-bezier(.5,0,.85,.55)'},
          {transform:`translate(${x}px,${y+3}px) rotate(0deg) scale(${s*1.12},${s*.88})`,offset:.72,easing:'ease-out'},
          {transform:`translate(${x}px,${y-16}px) scale(${s*.97},${s*1.04})`,offset:.84,easing:'ease-in'},
          {transform:`translate(${x}px,${y+1}px) scale(${s*1.04},${s*.96})`,offset:.94,easing:'ease-out'},
          {transform:`translate(${x}px,${y}px) scale(${s})`,offset:1}
        ], {duration:820,fill:'forwards'});
        const clean = () => { destination.style.visibility = ''; ghost.remove(); this.animations.delete(animation); };
        animation.nfCleanup = clean;
        this.animations.add(animation);
        animation.onfinish = clean; animation.oncancel = clean;
      } catch (_) { destination.style.visibility = ''; this.querySelectorAll('.nf-flying-image').forEach(el => el.remove()); }
    }
    paint() {
      const options = [this.option(this.drops,'Lemon Ice'),this.option(this.melts,'Extra Strong'),['','Single','Double','Triple + 1 free'][this.n]];
      const remaining = this.drops.concat(this.melts).filter(v => !v).length;
      this.querySelector('[data-nf-progress]').textContent = this.t('progress',{count:this.n*2-remaining,total:this.n*2});
      this.querySelector('[data-nf-hint]').textContent = [...this.drops, ...this.melts].some(Boolean) ? this.t('remove_hint') : ''; 
      this.variant = remaining ? null : this.variants.get(options.join('|||'));
      this.dataset.complete = String(!remaining);
      this.querySelectorAll('[data-nf-tier]').forEach(b => b.setAttribute('aria-pressed',String(Number(b.dataset.nfTier) === this.n)));
      for (const group of ['drops','melts']) {
        const field = this.querySelector(`[data-nf-fieldset="${group}"]`);
        field.querySelector('.nf-slots').style.setProperty('--nf-slots',this.n);
        field.querySelector('[data-nf-counter]').textContent = `${this[group].filter(Boolean).length} / ${this.n}`;
        this.choices[group].forEach(b => { b.disabled = !this[group].includes(null); });
        field.querySelectorAll('[data-nf-slot]').forEach(slot => {
          const i = Number(slot.dataset.nfIndex), value = this[group][i];
          slot.hidden = i >= this.n;
          slot.dataset.filled = String(!!value);
          const image = slot.querySelector('img'), remove = slot.querySelector('[data-nf-remove]');
          image.hidden = remove.hidden = !value;
          slot.querySelector('[data-nf-empty]').hidden = !!value;
          slot.querySelector('[data-nf-slot-label]').textContent = value || slot.dataset.nfLabel;
          if (value) {
            const src = this.choices[group].get(value).querySelector('img').getAttribute('src');
            if (image.getAttribute('src') !== src) image.setAttribute('src',src);
            image.alt = `${value} ARK ${group === 'drops' ? 'Drops' : 'Melts'}`;
            remove.setAttribute('aria-label',this.t('remove_product',{product:value,slot:slot.dataset.nfLabel}));
          } else { image.removeAttribute('src'); image.alt = ''; }
        });
      }
      const gift = this.querySelector('[data-nf-gift]');
      const revealGift = this.n === 3 && !this.giftShown && this.dataset.ready === 'true';
      this.giftShown = this.n === 3;
      gift.hidden = !this.giftShown;
      this.valid = !!this.variant && this.variant.available === true;
      this.form.elements.id.value = this.variant?.id || '';
      this.form.elements.quantity.value = '1';
      this.form.elements.id.disabled = !this.valid;
      this.submit.disabled = !this.valid || this.config.preview;
      this.paintPurchase();
      this.status.textContent = remaining ? '' : !this.variant ? this.t('mix_unavailable') : this.config.preview ? this.t('draft') : !this.variant.available ? this.t('sold_out') : '';
      if (revealGift) this.celebrateGift(gift);
    }
  }
  customElements.define('neurofuel-test-builder',NeurofuelTestBuilder);
})();
